<div class="section-page">
  <div class="container">
    <h3 class="title">Veja os artigos mais acessados</h3>
    <div class="row">
        <div class="col-12 col-lg-6">
            <ul class="categories list-unstyled">
                <h4
                    (click)="redirectTag('Contatos')"
                    (keydown.enter)="redirectTag('Contatos')"
                    (keydown.space)="redirectTag('Contatos')"
                    tabindex="0"
                    role="button"
                    class="button"
                    >Contatos
                </h4>
                <li class="redirectArticle"
                    (click)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000178192-como-integrar-com-um-sistema-via-webhook-de-entrada')"
                    (keydown.enter)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000178192-como-integrar-com-um-sistema-via-webhook-de-entrada')"
                    (keydown.space)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000178192-como-integrar-com-um-sistema-via-webhook-de-entrada')"
                    tabindex="0"
                    role="button"
                    class="button"
                    >
                    <span class="bullet">‣</span>
                    <span class="text">Como integrar com um sistema via Webhook de entrada</span>
                </li>
                <li
                    (click)="redirectArticle('/category/api/article/4000107924-documentacao-de-api')"
                    (keydown.enter)="redirectArticle('/category/api/article/4000107924-documentacao-de-api')"
                    (keydown.space)="redirectArticle('/category/api/article/4000107924-documentacao-de-api')"
                    tabindex="0"
                    role="button"
                    class="button"
                    >
                    <span class="bullet">‣</span>
                    <span class="text">Documentação de API do Dinamize</span>
                </li>
                <li
                    (click)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000187574-como-integrar-com-a-traycorp-%2528wake%2529')"
                    (keydown.enter)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000187574-como-integrar-com-a-traycorp-%2528wake%2529')"
                    (keydown.space)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000187574-como-integrar-com-a-traycorp-%2528wake%2529')"
                    tabindex="0"
                    role="button"
                    class="button"
                    >
                    <span class="bullet">‣</span>
                    <span class="text">Como integrar com a TrayCorp (Wake)</span>
                </li>
            </ul>
        </div>
        <div class="col-12 col-lg-6">
            <ul class="categories list-unstyled">
            <h4
                (click)="redirectTag('Integrações, Webhooks e API')"
                (keydown.enter)="redirectTag('Integrações, Webhooks e API')"
                (keydown.space)="redirectTag('Integrações, Webhooks e API')"
                tabindex="0"
                role="button"
                class="button"
                >Integrações, Webhooks e API
            </h4>
            <li
                (click)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000210835-como-configurar-uma-lista-de-produtos-%2528via-xml%2529')"
                (keydown.enter)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000210835-como-configurar-uma-lista-de-produtos-%2528via-xml%2529')"
                (keydown.space)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000210835-como-configurar-uma-lista-de-produtos-%2528via-xml%2529')"
                tabindex="0"
                role="button"
                class="button"
                >
                <span class="bullet">‣</span>
                <span class="text">Como configurar uma Lista de Produtos (via XML)</span>
            </li>
            <li
                (click)="redirectArticle('/category/importacao/article/4000196337-como-importar-contatos-via-upload-de-arquivo---planilha')"
                (keydown.enter)="redirectArticle('/category/importacao/article/4000196337-como-importar-contatos-via-upload-de-arquivo---planilha')"
                (keydown.space)="redirectArticle('/category/importacao/article/4000196337-como-importar-contatos-via-upload-de-arquivo---planilha')"
                tabindex="0"
                role="button"
                class="button"
                >
                <span class="bullet">‣</span>
                <span class="text">Como importar contatos via Upload de arquivo - Planilha</span>
            </li>
            <li
                (click)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000101998-ips-de-acesso-e-chaves-ao-ftp-ou-sftp-na-importacao-de-contatos')"
                (keydown.enter)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000101998-ips-de-acesso-e-chaves-ao-ftp-ou-sftp-na-importacao-de-contatos')"
                (keydown.space)="redirectArticle('/category/integracoes-com-outros-sistemas/article/4000101998-ips-de-acesso-e-chaves-ao-ftp-ou-sftp-na-importacao-de-contatos')"
                tabindex="0"
                role="button"
                class="button"
                >
                <span class="bullet">‣</span>
                <span class="text">IPs de acesso e Chaves ao FTP ou SFTP na importação de contatos</span>
            </li>
        </ul>
    </div>
    <div class="col-12 col-lg-6">
        <ul class="categories list-unstyled">
            <h4
                (click)="redirectTag('Configurações')"
                (keydown.enter)="redirectTag('Configurações')"
                (keydown.space)="redirectTag('Configurações')"
                tabindex="0"
                role="button"
                class="button"
                >Configurações
            </h4>
            <li
                (click)="redirectArticle('/category/usuarios-e-permissoes/article/4000085418-como-criar-um-novo-usuario-para-acesso-a-ferramenta')"
                (keydown.enter)="redirectArticle('/category/usuarios-e-permissoes/article/4000085418-como-criar-um-novo-usuario-para-acesso-a-ferramenta')"
                (keydown.space)="redirectArticle('/category/usuarios-e-permissoes/article/4000085418-como-criar-um-novo-usuario-para-acesso-a-ferramenta')"
                tabindex="0"
                role="button"
                class="button"
                >
                <span class="bullet">‣</span>
                <span class="text">Como criar um novo usuário para acesso a ferramenta</span>
            </li>
            <li
                (click)="redirectArticle('/category/usuarios-e-permissoes/article/4000109473-como-alterar-ou-recuperar-sua-senha-de-acesso')"
                (keydown.enter)="redirectArticle('/category/usuarios-e-permissoes/article/4000109473-como-alterar-ou-recuperar-sua-senha-de-acesso')"
                (keydown.space)="redirectArticle('/category/usuarios-e-permissoes/article/4000109473-como-alterar-ou-recuperar-sua-senha-de-acesso')"
                tabindex="0"
                role="button"
                class="button"
                >
                <span class="bullet">‣</span>
                <span class="text">Como alterar ou recuperar sua senha de acesso</span>
            </li>
            <li
                (click)="redirectArticle('/category/usuarios-e-permissoes/article/4000172916-requisitos-funcionais-para-os-usuarios-e-permissoes')"
                (keydown.enter)="redirectArticle('/category/usuarios-e-permissoes/article/4000172916-requisitos-funcionais-para-os-usuarios-e-permissoes')"
                (keydown.space)="redirectArticle('/category/usuarios-e-permissoes/article/4000172916-requisitos-funcionais-para-os-usuarios-e-permissoes')"
                tabindex="0"
                role="button"
                class="button"
                >
                <span class="bullet">‣</span>
                <span class="text">Requisitos funcionais para os Usuários e Permissões</span>
            </li>
        </ul>
    </div>
    <div class="col-12 col-lg-6">
        <ul class="categories list-unstyled">
            <h4
                (click)="redirectTag('Usuários e Permissões')"
                (keydown.enter)="redirectTag('Usuários e Permissões')"
                (keydown.space)="redirectTag('Usuários e Permissões')"
                tabindex="0"
                role="button"
                class="button"
                >Usuários e Permissões
            </h4>
            <li
                (click)="redirectArticle('/category/email/article/4000192111-boas-praticas-na-utilizacao-de-links-no-email-marketing')"
                (keydown.enter)="redirectArticle('/category/email/article/4000192111-boas-praticas-na-utilizacao-de-links-no-email-marketing')"
                (keydown.space)="redirectArticle('/category/email/article/4000192111-boas-praticas-na-utilizacao-de-links-no-email-marketing')"
                tabindex="0"
                role="button"
                class="button"
                >
                <span class="bullet">‣</span>
                <span class="text">Boas práticas na utilização de links no email marketing</span>
            </li>
            <li
                (click)="redirectArticle('/category/email/article/4000173198-enviando-seu-primeiro-email')"
                (keydown.enter)="redirectArticle('/category/email/article/4000173198-enviando-seu-primeiro-email')"
                (keydown.space)="redirectArticle('/category/email/article/4000173198-enviando-seu-primeiro-email')"
                tabindex="0"
                role="button"
                class="button"
                >
                <span class="bullet">‣</span>
                <span class="text">Enviando seu primeiro email</span>
            </li>
            <li
                (click)="redirectArticle('/category/email/article/4000136422-como-personalizar-os-parametros-%2528utms%2529-do-google-analytics-nos-seus-envios')"
                (keydown.enter)="redirectArticle('/category/email/article/4000136422-como-personalizar-os-parametros-%2528utms%2529-do-google-analytics-nos-seus-envios')"
                (keydown.space)="redirectArticle('/category/email/article/4000136422-como-personalizar-os-parametros-%2528utms%2529-do-google-analytics-nos-seus-envios')"
                tabindex="0"
                role="button"
                class="button"
                >
                <span class="bullet">‣</span>
                <span class="text">Como personalizar os parâmetros (utms) do Google Analytics nos seus envios</span>
            </li>
        </ul>
    </div> 
</div>